module.exports = __webpack_public_path__ + "media/application/images/icons/side-menu-arrow-a54de8ad62464f442f7b80811e2eb9a3.svg";